import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SiteHeader from "@/components/layout/SiteHeader";
import SiteFooter from "@/components/layout/SiteFooter";
import ScrollToTop from "@/components/layout/ScrollToTop";
import HomePage from "@/pages/HomePage";
import EntreprisePage from "@/pages/EntreprisePage";
import RealisationsPage from "@/pages/RealisationsPage";
import ZonePage from "@/pages/ZonePage";
import ContactPage from "@/pages/ContactPage";
import TerrassementPage from "@/pages/services/TerrassementPage";
import DemolitionPage from "@/pages/services/DemolitionPage";
import GenieCivilVoirieEnrobesPage from "@/pages/services/GenieCivilVoirieEnrobesPage";
import AmenagementsEnrochementPage from "@/pages/services/AmenagementsEnrochementPage";
import PrestationsIndexPage from "@/pages/services/PrestationsIndexPage";
import NotFoundPage from "@/pages/NotFoundPage";
import CookieConsent from "@/components/marketing/CookieConsent";

function Layout({ children }) {
    const location = useLocation();
    const isHome = location.pathname === "/";
    return (
        <div className="App" data-testid="site-shell">
            <SiteHeader transparent={isHome} />
            <main id="main" className={isHome ? "" : "pt-[80px]"} data-testid="site-main">
                {children}
            </main>
            <SiteFooter />
            <Toaster richColors position="top-center" />
            <CookieConsent />
        </div>
    );
}

function App() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Layout>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/entreprise" element={<EntreprisePage />} />
                    <Route path="/prestations" element={<PrestationsIndexPage />} />
                    <Route path="/prestations/terrassement" element={<TerrassementPage />} />
                    <Route path="/prestations/demolition-deconstruction" element={<DemolitionPage />} />
                    {/* Ancienne URL → redirection vers la nouvelle */}
                    <Route path="/prestations/demolition" element={<DemolitionPage />} />
                    <Route path="/prestations/genie-civil-voirie-enrobes" element={<GenieCivilVoirieEnrobesPage />} />
                    <Route path="/prestations/amenagements-exterieurs-enrochement" element={<AmenagementsEnrochementPage />} />
                    <Route path="/prestations/amenagements-enrochement" element={<AmenagementsEnrochementPage />} />
                    {/* Anciennes URLs → redirections vers les nouvelles pages fusionn\u00e9es */}
                    <Route path="/prestations/genie-civil-voirie" element={<GenieCivilVoirieEnrobesPage />} />
                    <Route path="/prestations/enrobes" element={<GenieCivilVoirieEnrobesPage />} />
                    <Route path="/prestations/amenagements-enrochage" element={<AmenagementsEnrochementPage />} />
                    <Route path="/realisations" element={<RealisationsPage />} />
                    <Route path="/zone-intervention" element={<ZonePage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="*" element={<NotFoundPage />} />
                </Routes>
            </Layout>
        </BrowserRouter>
    );
}

export default App;
